import { Button, ResponsiveDialog } from 'ui';

export default function GodaddyConfirmLargerTaskModal({ handleGodaddyDone }: { handleGodaddyDone: () => void }) {


    return (
        <ResponsiveDialog.Content
            className="text-textcolor isolate max-w-[512px] m-auto my-0 border-none  "
            onInteractOutside={(event: { preventDefault: () => unknown; }) => event.preventDefault()}
            container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
        >
            <div className="w-full flex flex-col items-center justify-center mt-6 rounded-[18px] bg-background">
                <span className=' text-center w-full font-medium mb-[20px] '>
                    You are about to submit your revisions to your website builder, and
                    we are excited to get to work!
                </span>
                <div className="text-left font-normal text-sm ">
                    <div>
                        <span className='mb-[-20px] font-normal'>
                            We see that you have a larger-than-average number of revisions
                            to submit. If there is any delay needed to ensure your site
                            returns to you in this improved, revised state, we will reach
                            out to you directly. Thank you!
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex justify-end gap-2 py-4">
                <Button
                    onClick={handleGodaddyDone}
                    size="sm"
                    className="w-1/2"
                >
                    Submit
                </Button>
            </div>
        </ResponsiveDialog.Content >
    );
}
